"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomButtonType = exports.CustomVariableType = exports.StaticVariableTag = exports.StaticVariableFormatKey = void 0;
var StaticVariableFormatKey;
(function (StaticVariableFormatKey) {
    StaticVariableFormatKey["FirstName"] = "common.firstName";
    StaticVariableFormatKey["LastName"] = "common.lastName";
    StaticVariableFormatKey["LastAmount"] = "common.lastAmount";
})(StaticVariableFormatKey || (exports.StaticVariableFormatKey = StaticVariableFormatKey = {}));
var StaticVariableTag;
(function (StaticVariableTag) {
    StaticVariableTag["FirstName"] = "{{firstname}}";
    StaticVariableTag["LastName"] = "{{lastname}}";
    StaticVariableTag["LastAmount"] = "{{last_amount}}";
})(StaticVariableTag || (exports.StaticVariableTag = StaticVariableTag = {}));
var CustomVariableType;
(function (CustomVariableType) {
    CustomVariableType["MagicalLink"] = "MagicalLink";
    CustomVariableType["PrefilledForm"] = "PrefilledForm";
    CustomVariableType["ETicketUrl"] = "ETicketUrl";
    CustomVariableType["ViewTickets"] = "ViewTickets";
    CustomVariableType["Date"] = "Date";
    CustomVariableType["Location"] = "Location";
})(CustomVariableType || (exports.CustomVariableType = CustomVariableType = {}));
var CustomButtonType;
(function (CustomButtonType) {
    CustomButtonType["FormLink"] = "FormLink";
    CustomButtonType["CustomLink"] = "CustomLink";
})(CustomButtonType || (exports.CustomButtonType = CustomButtonType = {}));
